export const getFontSize = (fontSize) => {
  const baseFontSize = 1.3;
  return fontSize / baseFontSize;
};
